import { ButtonHTMLAttributes, forwardRef } from 'react';
import { Tooltip } from '@/components/ui/Tooltip';
import { cn } from '@/utils/cn';

/**
 * CancelButton - Icon-only cancel/close button for modal footers.
 *
 * Matches old codebase pattern: square icon button with close icon.
 * White bg, black border, hover fills black.
 */

interface CancelButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Tooltip text (defaults to "Cancel") */
  tooltip?: string;
}

export const CancelButton = forwardRef<HTMLButtonElement, CancelButtonProps>(({
  tooltip = 'Cancel',
  className,
  ...props
}, ref) => (
  <Tooltip content={tooltip} side="bottom">
    <button
      ref={ref}
      type="button"
      className={cn(
        'w-[44px] h-[44px] sm:w-10 sm:h-10 flex items-center justify-center rounded-md',
        'bg-white text-bs-black',
        'border border-bs-black',
        'hover:bg-bs-black hover:text-white',
        'transition-colors duration-200',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className
      )}
      aria-label={tooltip}
      {...props}
    >
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span className="material-symbols-outlined leading-none" style={{ fontSize: 'clamp(16px, 2vw, 20px)' }}>close</span>
    </button>
  </Tooltip>
));

CancelButton.displayName = 'CancelButton';
